import type { DatePickerHeaderProps } from './DatePickerHeader.types'
import React from 'react'
import { IconButton } from '../../icon-button'
import styles from './DatePickerHeader.module.css'

export function DatePickerHeader({
  customHeaderCount,
  decreaseMonth,
  increaseMonth,
  localeString,
  monthDate,
  monthsShown = 1,
  nextMonthAriaLabel,
  nextMonthButtonDisabled,
  prevMonthButtonDisabled,
  previousMonthAriaLabel,
}: DatePickerHeaderProps) {
  const monthTitle = monthDate.toLocaleDateString(localeString, { month: 'long', year: 'numeric' })
  const isFirstShownMonth = customHeaderCount === 0
  const showNextMonthButton = !isFirstShownMonth || monthsShown === 1

  const handleIconKeyDown = (event: React.KeyboardEvent, callback: () => void) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      callback()
    }
  }

  return (
    <div className={styles.datePickerHeader}>
      <div className={styles.sideControlLeft}>
        {isFirstShownMonth && (
          <IconButton
            glyph="ChevronLeft"
            size="S"
            variant="secondary"
            onClick={decreaseMonth}
            onKeyDown={!prevMonthButtonDisabled ? (event: React.KeyboardEvent) => handleIconKeyDown(event, decreaseMonth) : undefined}
            disabled={prevMonthButtonDisabled}
            aria-label={previousMonthAriaLabel}
            tabIndex={0}
          />
        )}
      </div>
      <div className={styles.currentMonth}>{monthTitle}</div>
      <div className={styles.sideControlRight}>
        {showNextMonthButton && (
          <IconButton
            glyph="ChevronRight"
            size="S"
            variant="secondary"
            onClick={increaseMonth}
            onKeyDown={!nextMonthButtonDisabled ? (event: React.KeyboardEvent) => handleIconKeyDown(event, increaseMonth) : undefined}
            disabled={nextMonthButtonDisabled}
            aria-label={nextMonthAriaLabel}
            tabIndex={0}
          />
        )}
      </div>
    </div>
  )
}
